export const queryKeys = {
  auth: { me: ['auth', 'me'] as const },
  roles: {
    all: ['roles'] as const,
    list: ['roles', 'list'] as const,
    detail: (id: string) => ['roles', 'detail', id] as const,
  },
  permissions: {
    all: ['permissions'] as const,
    registry: ['permissions', 'registry'] as const,
  },
  parcels: {
    all: ['parcels'] as const,
    list: (params: object) => ['parcels', 'list', params] as const,
    detail: (id: string) => ['parcels', 'detail', id] as const,
    products: (parcelId: string) => ['parcels', parcelId, 'products'] as const,
  },
  parties: {
    all: ['parties'] as const,
    list: (params: object) => ['parties', 'list', params] as const,
    detail: (id: string) => ['parties', 'detail', id] as const,
  },
  packages: {
    all: ['packages'] as const,
    list: (params: object) => ['packages', 'list', params] as const,
    detail: (id: string) => ['packages', 'detail', id] as const,
    parcelPicker: (params: object) => ['packages', 'parcel-picker', params] as const,
  },
  splits: {
    all: ['splits'] as const,
    list: (params: object) => ['splits', 'list', params] as const,
    detail: (id: string) => ['splits', 'detail', id] as const,
    pendingCount: ['splits', 'pending-count'] as const,
  },
  categories: { all: ['categories'] as const },
  clients: {
    all: ['clients'] as const,
    list: (params: object) => ['clients', 'list', params] as const,
    detail: (id: string) => ['clients', 'detail', id] as const,
    claimedTrekIds: (id: string) => ['clients', 'claimed-trek-ids', id] as const,
    receipts: (id: string) => ['clients', 'receipts', id] as const,
  },
  legacyClients: {
    all: ['legacy-clients'] as const,
    list: (params: object) => ['legacy-clients', 'list', params] as const,
    detail: (id: string) => ['legacy-clients', 'detail', id] as const,
  },
  staff: {
    all: ['staff'] as const,
    list: (params: object) => ['staff', 'list', params] as const,
    detail: (id: string) => ['staff', 'detail', id] as const,
  },
  supportStaff: {
    all: ['support-staff'] as const,
    list: (params: object) => ['support-staff', 'list', params] as const,
    detail: (id: string) => ['support-staff', 'detail', id] as const,
  },
  cargoIds: {
    all: ['cargo-ids'] as const,
    list: (params: object) => ['cargo-ids', 'list', params] as const,
    detail: (id: string) => ['cargo-ids', 'detail', id] as const,
    parcels: (id: string, page: number) => ['cargo-ids', id, 'parcels', page] as const,
    lookupByCode: (code: string) => ['cargo-ids', 'lookup', 'code', code] as const,
    lookupInfinite: (q: string) => ['cargo-ids', 'lookup', 'infinite', q] as const,
  },
  warehouseProducts: {
    all: ['warehouse-products'] as const,
    list: (params: object) => ['warehouse-products', 'list', params] as const,
    detail: (id: string) => ['warehouse-products', 'detail', id] as const,
  },
  warehouse: {
    // Tab 1 on the Omborxona page — parcels with an owner in an active
    // workflow state. Distinct from the orphan list (which uses
    // ``warehouseProducts``).
    all: ['warehouse'] as const,
    owned: (params: object) => ['warehouse', 'owned', params] as const,
  },
  warehouseArrivals: {
    all: ['warehouse-arrivals'] as const,
    packagesList: (params: object) => ['warehouse-arrivals', 'packages', 'list', params] as const,
    packageDetail: (id: string) => ['warehouse-arrivals', 'packages', 'detail', id] as const,
    parcelsList: (params: object) => ['warehouse-arrivals', 'parcels', 'list', params] as const,
    parcelDetail: (id: string) => ['warehouse-arrivals', 'parcels', 'detail', id] as const,
  },
  dashboard: ['dashboard'] as const,
  pinfl: {
    all: ['pinfl'] as const,
    detail: (pinfl: string, excludeParcel?: string) =>
      excludeParcel
        ? (['pinfl', pinfl, excludeParcel] as const)
        : (['pinfl', pinfl] as const),
  },
  limitConfig: ['limit-config'] as const,
  pricing: ['pricing-config'] as const,
  charges: {
    all: ['charges'] as const,
    list: (params: object) => ['charges', 'list', params] as const,
  },
  reports: {
    all: ['reports'] as const,
    list: (params: object) => ['reports', 'list', params] as const,
    pendingCount: ['reports', 'pending-count'] as const,
  },
  returns: {
    all: ['returns'] as const,
    list: (params: object) => ['returns', 'list', params] as const,
    pendingCount: ['returns', 'pending-count'] as const,
  },
  faqs: { all: ['faqs'] as const },
  supportChat: {
    all: ['support-chat'] as const,
    conversations: (params: object) => ['support-chat', 'conversations', params] as const,
    // Prefix key covering every conversations-LIST query regardless of params.
    // Invalidate this (not `all`) so the open conversation thread isn't force-
    // refetched on every incoming/sent message.
    conversationsList: ['support-chat', 'conversations'] as const,
    conversation: (userId: string) => ['support-chat', 'conversation', userId] as const,
    unreadCount: ['support-chat', 'unread-count'] as const,
  },
} as const;
